import React from 'react';

export default function MapSection({ venue, mapUrl }) {
  const mapSrc =
    mapUrl ||
    (venue
      ? `https://www.google.com/maps?q=${encodeURIComponent(venue)}&output=embed`
      : null);

  if (!mapSrc) return null;

  return (
    <div className="containers-min mx-auto px-4 pb-12">
      <h3 className="font-gilroy mb-6">Location</h3>
      <p className="font-poppins text-black/70 mb-4">{venue}</p>
      <div className="rounded-2xl overflow-hidden border border-black/10  h-[500px]">
        <iframe
          title={`Map to ${venue}`}
          src={mapSrc}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}
